import type { Proposta } from '@/types'

/** Normaliza resposta de GET /deals/:id/proposals (array direto ou envelope). */
export function normalizeProposalsList(payload: unknown): Proposta[] {
  if (Array.isArray(payload)) return payload as Proposta[]
  if (payload && typeof payload === 'object') {
    const data = (payload as { data?: unknown }).data
    if (Array.isArray(data)) return data as Proposta[]
  }
  return []
}

/** Normaliza resposta de POST/PATCH /propostas. */
export function normalizePropostaResponse(payload: unknown): Proposta | null {
  if (!payload || typeof payload !== 'object') return null
  const inner = (payload as { data?: unknown }).data
  if (inner && typeof inner === 'object' && 'id' in (inner as object)) {
    return inner as Proposta
  }
  if ('id' in payload) return payload as Proposta
  return null
}
